import { render, staticRenderFns } from "./zhongzixiaofeilist.vue?vue&type=template&id=10c1cc16&"
import script from "./zhongzixiaofeilist.vue?vue&type=script&lang=js&"
export * from "./zhongzixiaofeilist.vue?vue&type=script&lang=js&"
import style0 from "./zhongzixiaofeilist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports